module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column"
  }, [_c('input', {
    staticClass: "inter f6 input-reset ba db mr3 br2 code-input",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "input": _vm.onChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-theme f6 mt2 mr3 w-40 mb2 w-100",
    class: {
      invisible: !this.isError || !this.inputValue
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afeaa5a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/forms/AkkoInput.vue
// module id = 788
// module chunks = 0